import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IContactModel } from '@apps-common/types/management/contact'

export const updateContact = async (model: IContactModel): Promise<IContactModel> =>
  axios.post(`/management/contact/updatecontact`, model).then((res) => res?.data?.data)

type Props = {
  model: IContactModel
}

export const useManagementUpdateContact = (notify?: boolean, onSuccess?: (data: IContactModel) => void) =>
  useMutation({
    mutationKey: ['updateContact'],
    mutationFn: ({ model }: Props) => updateContact(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated contact.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update contact, please try again.')
      }
    },
    throwOnError: false
  })
